/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import tw from "twin.macro"
import { CSSTransition, TransitionGroup } from "react-transition-group"

import { Social } from "@components"
import { Chevron } from "@components/icons"
import { ButtonPrimary } from "@templates"
import { navDelay, loaderDelay } from "@utils"
import { navLinks, colors } from "@config"

const StyledHero = styled.section`
  ${tw`px-8 flex flex-col justify-center min-h-screen text-suvaGrey md:px-4`}
  & {
    .top-tag {
      ${tw`text-neutralLight`}
      line-height: 0.8;
    }
    .heading {
      ${tw`font-mw font-medium text-5xl md:text-7xl m-0`}
      line-height: 1.1;
    }
    .descriptor {
      ${tw`mt-6 mb-10 md:w-1/2`}
    }
  }
`

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => setIsMounted(true), navDelay)
    return () => clearTimeout(timeout)
  }, [])

  const one = <p className="top-tag">Hello👋! This is</p>
  const two = (
    <h1 className="heading" tw="text-neutralLight">
      Anubhav, a student
    </h1>
  )
  const three = <h1 className="heading">On a knowledge quest.</h1>
  const four = (
    <p className="descriptor">
      I am <span>Software Design Engineer</span> based in India. 
      Passionate about innovation, I explore immersive technologies 
      and have recently developed a keen interest in Quantum Science, 
      driven by curiosity to learn and discover new possibilities.
    </p>
  )
  const five = (
    <ButtonPrimary color={colors.neonPurple} hover="purple">
      <Link to={navLinks.find(el => el.name === "Projects").url}>
        <span>See my Projects</span>
        <Chevron />
      </Link>
    </ButtonPrimary>
  )

  const items = [one, two, three, four, five]

  return (
    <StyledHero>
      <TransitionGroup component={null}>
        {isMounted &&
          items.map((item, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
              <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
            </CSSTransition>
          ))}
      </TransitionGroup>
      <TransitionGroup>
        {isMounted && (
          <CSSTransition classNames="fadeup social-div" timeout={loaderDelay}>
            <Social
              position="hero"
              style={{ transitionDelay: `${items.length * 2}00ms` }}
            />
          </CSSTransition>
        )}
      </TransitionGroup>
    </StyledHero>
  )
}

export default Hero
